import React, { useRef, useCallback } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

export default function useReCAPTCHA(siteKey) {

  const ref = useRef(null)

  const getReCAPTCHAToken = useCallback(async () => {
    ref.current?.reset()
    return await ref.current?.executeAsync()
  }, [])

  const ReCAPTCHAComponent = (
    <ReCAPTCHA
      size="invisible"
      sitekey={siteKey}
      ref={ref}
      onErrored={(e) => console.error('ReCAPTCHA errored', e)}
      onExpired={(e) => console.log('ReCAPTCHA expired', e)}
    />
  )

  return { ReCAPTCHAComponent, getReCAPTCHAToken }
}